import { INutritionService, NvzPlanCropping } from "../types";

export function checkApplicationDate(appDate: Date, crops: NvzPlanCropping[], svc: INutritionService): boolean {

    crops = crops || [];

    if (!crops.length) {
        return true;
    }

    return crops.every(c => {

        const perennial = c.cropping.Crop.Perennial

        let startDate = new Date(svc.cropYear.StartDate.valueOf()).addMonths(-1)

        let endDate = new Date(svc.cropYear.EndDate.valueOf())

        // Plans are now allowed on perennial crops up to the end of October
        endDate = endDate.addMonths(perennial ? 3 : 1)

        if (c.cropping.SowingDate < startDate) {
            startDate = c.cropping.SowingDate
        }

        if (c.cropping.EndDate > endDate) {
            endDate = c.cropping.EndDate
        }

        if (appDate < startDate) return false
        if (appDate > endDate) return false

        return true

    });

}
